export default "__VITE_ASSET__c1485a4e__"